import './App.css';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';

import Navbar from './components/Navbar';
import Footer from './components/Footer';
import EnquiryPopup from './components/EnquiryPopup';
import FloatingContactButtons from './components/FloatingContactButtons';

// Pages
import Home from './pages/Home';
import Necklaces from './pages/Necklaces';
import Rings from './pages/Rings';
import Shop from './pages/Shop';
import GoldJewellery from './pages/GoldJewellery';
import DiamondJewellery from './pages/DiamondJewellery';
import SilverCollection from './components/SilverCollection';
import TransformationJourney from './pages/TransformationJourney';
import TermsAndConditions from './pages/TermsAndConditions';
import PrivacyPolicy from './pages/PrivacyPolicy';
import PaymentTerms from './pages/PaymentTerms';
import ContactSection from './components/ContactSection';

function App() {
  return (
    <Router>
      <Navbar />
      <EnquiryPopup />
      <FloatingContactButtons />

      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/necklaces" element={<Necklaces />} />
        <Route path="/ring" element={<Rings />} />
        <Route path="/shop" element={<Shop />} />
        <Route path="/contact" element={<ContactSection />} />
        <Route path="/goldjwellery" element={<GoldJewellery />} />
        <Route path="/dimondjewellery" element={<DiamondJewellery />} />
        <Route path="/silver" element={<SilverCollection />} />
        <Route path="/transformation" element={<TransformationJourney />} />
        <Route path="/terms" element={<TermsAndConditions />} />
        <Route path="/privacy-policy" element={<PrivacyPolicy />} />
        <Route path="/payment" element={<PaymentTerms />} />
      </Routes>

      <Footer />
    </Router>
  );
}

export default App;